import type React from 'react';

/**
 * Header background for the hand-built report tables (QBS Summary, Quantified Value, Quantified
 * Costing). The Tailwind `surface-alt` token; set inline because sticky header cells need an opaque
 * background over the rows scrolling under them.
 */
export const REPORT_HEADER_BG = '#f8fafc';

/**
 * Sticky header cell shared by those tables: centred, wraps onto two lines so columns stay as narrow
 * as their numbers, and stays on top while the body scrolls.
 */
export function reportHeaderCellStyle(minWidth: string, extra?: React.CSSProperties): React.CSSProperties {
  return {
    minWidth,
    textAlign: 'center',
    whiteSpace: 'normal',
    lineHeight: 1.2,
    verticalAlign: 'bottom',
    backgroundColor: REPORT_HEADER_BG,
    position: 'sticky',
    top: 0,
    zIndex: 10,
    ...extra
  };
}
